import WirOptimieren from "./slides/WirOptimieren";
import SieHabenDieWahl from "./slides/SieHabenDieWahl";

export default function IndividuelleSchaumeinlagen() {
  return [
    <WirOptimieren key="wir-optimieren" />,
    <SieHabenDieWahl key="sie-haben-die-wahl" />,
  ];
}
